<div class="pt-8 pb-16 px-2 md:py-[30px] md:px-[50px]">
  @if (step === 1) {
    <div>
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-tongcheng-color-bg.svg" alt="" />
      <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
    </div>

    <div class="text-l font-bold mt-[30px]">
      {{ "channel-connect_tc_html_标题" | translate }}
    </div>

    <div class="text-m mt-[30px]">
      <div>
        {{ "channel-connect_tc_html_描述" | translate }}
      </div>
    </div>

    <div class="text-m mt-[30px]">
      <div>{{ "channel-connect_tc_html_注意事项1" | translate }}</div>
      <div>{{ "channel-connect_tc_html_注意事项2" | translate }}</div>
      <div>{{ "channel-connect_tc_html_注意事项3" | translate }}</div>
    </div>

    <div [class]="footerClass">
      <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="onCancel()">
        {{ "word.cancel" | translate }}
        <!-- Cancel -->
      </button>

      <button
        [class]="footerConfirmBtnClass"
        nz-button
        nzType="primary"
        nzSize="large"
        [nzLoading]="loading"
        (click)="step = 2">
        {{ "channel-connect_tc_html_开始直连" | translate }}
        <!-- Go to the Booking Site -->
      </button>
    </div>
  }

  @if (step === 2) {
    <div class="v4-layout-form text-left">
      <div class="v4-layout-form-title !font-bold">
        {{ "channel-connect_tc_html_您的账户" | translate }}
      </div>
      <div class="v4-layout-form-desc">
        {{ "channel-connect_tc_html_输入手机号" | translate }}
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <input
            type="text"
            nz-input
            nzSize="large"
            [(ngModel)]="mobile"
            [placeholder]="'channel-connect_tc_html_p_手机号' | translate" />
        </div>
      </div>

      <div [class]="footerClass">
        <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = 1">
          {{ "word.return" | translate }}
          <!-- Back -->
        </button>
        <button [class]="footerConfirmBtnClass" nz-button nzSize="large" nzType="primary" (click)="onSendVerifyCode()">
          {{ "word.next" | translate }}
          <!-- Next -->
        </button>
      </div>
    </div>
  }

  @if (step === 3) {
    <div class="v4-layout-form text-left">
      <div class="v4-layout-form-title !font-bold">
        {{ "channel-connect_tc_html_验证手机号" | translate }}
      </div>
      <div class="v4-layout-form-desc">
        {{ "channel-connect_tc_html_输入验证码" | translate }}
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <input
            type="text"
            nz-input
            nzSize="large"
            [(ngModel)]="code"
            [placeholder]="'channel-connect_tc_html_p_验证码' | translate" />
        </div>
      </div>

      <div [class]="footerClass">
        <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = 1">
          {{ "word.return" | translate }}
          <!-- Back -->
        </button>
        <button [class]="footerConfirmBtnClass" nz-button nzSize="large" nzType="primary" (click)="onAuth()">
          {{ "word.next" | translate }}
          <!-- Next -->
        </button>
      </div>
    </div>
  }

  @if (step === 4) {
    <div class="v4-layout-form text-left">
      <div class="v4-layout-form-title !font-bold">
        {{ "channel-connect_tc_html_添加想发布的房源" | translate }}
      </div>
      <div class="v4-layout-form-desc">
        {{ "channel-connect_tc_html_请选择房源" | translate }}
      </div>

      <div [class]="footerClass">
        <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = 1">
          {{ "word.return" | translate }}
          <!-- Back -->
        </button>
        <button
          [class]="footerConfirmBtnClass"
          nz-button
          nz-dropdown
          [nzDropdownMenu]="menu"
          nzSize="large"
          nzType="primary">
          {{ "thirdhub.pricelabs.operate.btn.add" | translate }}
          <!-- Next -->
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="onAddHouses('house')">
              {{ "component.sidebar.btn.add_house" | translate }}
              <!-- 添加房间 -->
            </li>
            <li nz-menu-item (click)="onAddHouses('type')">
              {{ "component.sidebar.btn.add_house_type" | translate }}
              <!-- 添加房型 -->
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  }

  @if (step === 5) {
    <div class="v4-layout-form text-left">
      <div class="v4-layout-form-title !font-bold">
        {{ "channel-connect_tc_html_等待同程处理" | translate }}
      </div>
      <div class="v4-layout-form-desc">
        {{ "channel-connect_tc_html_等待同程处理说明" | translate }}
      </div>

      <div [class]="footerClass">
        <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = 1">
          {{ "word.return" | translate }}
          <!-- Back -->
        </button>
        <button [class]="footerConfirmBtnClass" nz-button nzSize="large" nzType="primary" (click)="step = 6">
          {{ "word.i_know" | translate }}
          <!-- Next -->
        </button>
      </div>
    </div>
  }

  @if (step === 6) {
    <div class="v4-layout-form text-left">
      <div class="v4-layout-form-title !font-bold">
        {{ "channel-connect_tc_html_在同程完善房源" | translate }}
      </div>
      <div class="v4-layout-form-desc">
        {{ "channel-connect_tc_html_在同程完善房源说明" | translate }}
      </div>

      <div [class]="footerClass">
        <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="step = 1">
          {{ "word.return" | translate }}
          <!-- Back -->
        </button>
        <button [class]="footerConfirmBtnClass" nz-button nzSize="large" nzType="primary" (click)="onFinish()">
          {{ "channel-connect_tc_html_去同程app" | translate }}
        </button>
      </div>
    </div>
  }
</div>
